import * as types from "../actions/actionTypes";
import createEntityReducer from "./createEntityReducer";

export default createEntityReducer({
  entity: "auditlog",
  listKey: "logs",
  itemKey: "log",
  getAll: types.GET_ALL_AUDIT_LOGS,
  getAllResponse: types.GET_ALL_AUDIT_LOGS_RESPONSE,
  getByIdResponse: types.GET_AUDIT_LOG_BY_ID_RESPONSE,
});
